<script>
export default {
  computed: {
    canGoBack() {
      const numberOfEntries = window.history.length;
      return numberOfEntries > 2;
    },
  },
  methods: {
    goBack(fallbackRoute) {
      if (this.canGoBack) {
        this.$router.back();
      } else {
        this.$router.push(fallback);
      }
    },
  },
};
</script>
